import { Color } from '@/components/portfolio/components/sharedTypes'
import { clientHomeData, clientPageData, PortfolioComponent } from '../../type/client-index'
import { Delbove1, Delbove2, Delbove3, Delbove4, Delbove5, Delbove6, DelbovePresentation, Reel1, Reel2 } from './assets'

export const home: clientHomeData = {
  slug: 'delbove',
  name: 'Delbove',
  types: ['Création de contenu'],
  image: Delbove6
}

const detailed: clientPageData = {
  seo: {
    // Le titre est généré comme ça: {name} - Atelier Milky
    title: 'Delbove',
    description: 'Découvrez notre travail avec Delbove.'
  },
  blocks: [
    {
      id: 0,
      componentName: PortfolioComponent.presentationSlide,
      props: {
        title: home.name,
        titleColor: Color.blue,
        types: home.types,
        images: [DelbovePresentation],
        urls: {
          website: 'https://fr.delbove.com/fr',
          instagram: 'https://www.instagram.com/delboveskincare/'
        },
        subtitle: 'La marque',
        description: {
          cols: 2,
          content: [
            "Depuis maintenant plus de 50 ans, Delbôve propose des produits cosmétiques naturels. Grâce au mélange d'un savoir scientifique et du pouvoir des plantes médicinales, la marque vend des produits agissant directement sur les problèmes cutanés ou signes de vieillissement.",
            'Aux côtés du produit phare de la marque, la "Crème Sorcière", vous pourrez retrouver toutes sortes de cosmétiques allant du soin pour les yeux au masque anti-rougeurs !'
          ]
        }
      }
    },
    {
      id: 1,
      componentName: PortfolioComponent.fullHeightVideos,
      props: {
        pl: true,
        pr: true,
        variant: 4,
        videosCfIds: [Reel1, Reel2]
      }
    },
    {
      id: 2,
      componentName: PortfolioComponent.imageGrid,
      props: {
        title: 'Notre travail',
        cols: 2,
        rightPadding: true,
        spaceBetween: true,
        description: {
          cols: 1,
          content: [
            "La collaboration entre Delbôve et Atelier Milky a peut-être commencé avec la réalisation d'un reel mais continue d'évoluer de jour en jour ! C'est donc tout naturellement que nous avons emporté les produits de la marque lors de notre voyage au Maroc pour y réaliser du contenu. Un shooting produits, quelques reels et un shooting en magasin plus tard, nous sommes fiers de vous partager le résultat d'une collaboration long terme avec cette marque belge."
          ]
        },
        images: [Delbove1, Delbove2, Delbove3, Delbove4, Delbove5, Delbove6]
      }
    }
  ]
}

export default detailed
